import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'underscoreless',
    standalone: true,
})
export class UnderscorelessPipe implements PipeTransform {
    transform (value: string | unknown): string | unknown {
        if (!value || typeof value !== 'string') {
            return value;
        }
        return value
            .split('_')
            .join(' ');
    }
}
